<template>
  <div>
    <v-card flat class="conteneurLead" id="conteneurLead" style="width: 100%;">
        <v-card-title class="primary white--text"  style="height: 52px;  padding: 0px;">
          <v-btn icon @click="$emit('justCloseDialog')"><v-icon class="white--text">close</v-icon></v-btn>
          <div class="title tf_title_dialog" v-html="titleDialog"></div>
        </v-card-title>
        <v-card-text>
          <div class="text-xs-center ">
            <!--- liste de toutes les url -->
            <v-flex xs3 sm3>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  :label="this.$t('search')"
                  single-line
                  hide-details
                ></v-text-field>
            </v-flex>


            <v-flex xs12>
              <v-data-table
                :headers="headersFile"
                :items="chunks"
                :search="search"
                item-key="name"
                :loading="loadingData"
                class="elevation-1"
              >
              
                <template v-slot:progress><v-progress-linear height="2" color="blue" indeterminate></v-progress-linear></template>
                <template v-if="!loadingData" v-slot:items="props">
                  <tr @click.stop="openDialogUpdateKeyword(props)" >
                    <td class="text-xs-left">{{ props.item.name }}</td>
                    <td class="text-xs-left">{{ props.item.extrait }}</td>
                    <td class="text-xs-center px-2">
                    <!-- Editer -->
                    <v-tooltip left >
                      <template slot="activator">
                        <v-icon class="infos" color="black lighten-1" dark >info_outline</v-icon>
                      </template>
                      <span>{{$t('AIAffSeg')}}</span>
                    </v-tooltip>
                    </td>
                  </tr>
                </template>
                <template v-slot:expand="props">
                  

                  <v-card flat class="grey lighten-4" >
                    <v-card-text class="text-xs-left">
                      <v-textarea
                        box
                        name="content"
                        :label="this.$t('keywords')"
                        auto-grow
                        :value='props.item.content'
                        v-model="props.item.content"
                        @input="changeContent(props)"
                      ></v-textarea>
                    </v-card-text>
                  </v-card>

                </template>
              </v-data-table>
            </v-flex>
          </div>  
        </v-card-text>
        <v-card-actions>
          <v-flex xs3 sm3>
                <v-btn color="primary" dark flat @click="download()">{{ $t('exportInCsv') }}<v-icon color="primary" right>file_download</v-icon></v-btn>
            </v-flex>
          <v-spacer></v-spacer>
          <v-btn flat @click="$emit('justCloseDialog')">{{ $t('close') }}</v-btn>
        </v-card-actions>
    </v-card>

    <!-- dialog modif contenu chunk file-->
    <v-dialog
      v-model="showDialogModifKeyword"
      persistent
      scrollable
      max-width="550"
    >
      <wz-dialog-modif-content-file
        :titleDialog="this.$t('AIModifContentFAQ')"
        :afficheDialog="showDialogModifKeyword"
        :dataDialog="contentModif"
        :licKey="licKey"
        @closeDialog="justCloseDialogKeyword"
        @justCloseDialog="justCloseDialogKeyword"
        @majData="majData"
      ></wz-dialog-modif-content-file>
    </v-dialog>
  </div>
</template>



<script>
import json2csv from 'json2csv'
export default {
  props: {
    dataDialog: {
      type: Object,
      default: {}
    },
    titleDialog: {
      type: String,
      default: 'Confirmation'
    },
    licKey: {
      type: String
    },
    afficheDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      contentDialog: '',
      showDialogModifKeyword: false,
      loadingModif: false,
      loadingModifContent: false,
      modifContent: false,
      contentRef: '',
      contentModif: '',
      loading: false,
      updatedKeywords: false,
      chunks: [],
      headersFile: [
        { text: 'segments', align: 'left', value: 'name' },
        { text: 'contenu', align: 'left', value: 'content' },
        { text: 'info', align: 'right', value: 'info', sortable: false }
      ],
      loadingData: true,
      search: ''
    }
  },
  computed: {
    // url du bon serveur (prod / dev)
    serveurAI () {
      if (window.location.origin.indexOf('localhost') > -1) {
        return 'https://lb-sw-generator-dev-v2.watcheebox.net/'
      } else if (window.location.origin.indexOf('backoffice-preprod') > -1) {
        return 'https://lb-sw-generator-preprod-v2.watcheebox.net/'
      } else if (window.location.origin.indexOf('backoffice') > -1) {
        return 'https://lb-sw-generator.watcheebox.net/'
      } else {
        return 'https://lb-sw-generator.watcheebox.net/'
      }
    }
  },
  mounted () {},
  updated () {},
  methods: {
    closeDialog () {
      this.$emit('justCloseDialog')
    },
    changeContent (content) {
      console.log('le contenu change', content)
      this.modifContent = true
    },
    // ouvre le dialogue de modification le contenu du la section
    async openDialogUpdateKeyword (data) {
      // console.log('le contenu change', data)
      this.contentModif = data
      this.showDialogModifKeyword = true
    },
    justCloseDialogKeyword () {
      this.showDialogModifKeyword = false
    },
    // recupère le contenu selectionné
    async getChunkFiles (data) {
      // console.log('getChunkFiles', data)
      this.loadingData = true
      // console.log('this.faqDialog', this.faqDialog)
      // this.showDialogModifKeyword = true
      // console.log('open keyword', data)
      let dataToPost = {}
      dataToPost.data = data
      const response = await this.axios.post(this.serveurAI + 'getChunkFiles',
      dataToPost,
        {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
      )
      if (response.data.retour) {
        // console.log('response : ', response.data.data)
        this.chunks = response.data.data
        this.loadingData = false
        setTimeout(() => {
          this.loadingData = false
        }, 500)
      }
    },
    // mise à jour des données du BO
    majData (data) {
      // console.log('majData : ', data)
      // console.log('this.chunks', this.chunks)
      for (const index in this.chunks) {
        if (this.chunks[index].name === data.nameChunk) {
          this.chunks[index].content = data.content
          let extrait = data.content
          if (extrait && extrait.length > 200) {
            extrait = data.content.slice(0, 200) + '...'
          }
          this.chunks[index].extrait = extrait
        }
      }
    },

    download () {
      let csv = null
      const fields = [
        { text: 'segments', align: 'left', value: 'question' },
        { text: 'contenu', align: 'left', value: 'réponse' },
        { text: 'info', align: 'right', value: 'info', sortable: false }
      ]
      const fieldNames = this.headersFile.map(h => h.text)
      const data = []
      for (const qr of this.chunks) {
        qr.content = qr.content.replaceAll('Question : ', '')
        qr.content = qr.content.replaceAll('\n', '')
        qr.content = qr.content.replaceAll('\r', '')
        qr.content = qr.content.replaceAll('\t', '')
        let newArrayQR = qr.content.split('Réponse : ')
        // console.log('newArrayQR', newArrayQR)
        data.push({question: 'Question : ' + newArrayQR[0], réponse: 'Réponse : ' + newArrayQR[1], info: '\u266f\u266f\u266f'})
      }
      try {
        csv = json2csv({ data, fields, del: ';', fieldNames })
      } catch (err) {
        return
      }

      // téléchargement du fichier csv
      var hiddenElement = document.createElement('a')
      hiddenElement.href = 'data:attachment/text,' + encodeURI(csv)
      hiddenElement.target = '_blank'
      hiddenElement.download = 'FAQ.csv'
      document.body.appendChild(hiddenElement)
      hiddenElement.click()
    }
  },
  watch: {
    // detect quand la dialogBow est effiché
    afficheDialog: function (val, oldVal) {
      console.log('afficheDialog val :', val)
      if (val) {
        this.loading = true
        // chargement des segments de ce fichier
        console.log('dataDialog', this.dataDialog)
        this.getChunkFiles(this.dataDialog)
      }
    }
  }
}
</script>

<style scoped>
  .tf_title_dialog {
    text-overflow: ellipsis;
    width: calc(100% - 180px);
    overflow: hidden;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/watcheezy/WzDialogFileChunk.vue